import { useCallback, useState } from "react";

export interface PhonePosition {
  lat: number;
  lon: number;
  accuracy: number;
}

const POSITION_TIMEOUT_MS = 15_000;

/** One fresh position per call (no tracking); needs https and the user's permission. */
export function usePhonePosition() {
  const [error, setError] = useState<string>();

  const request = useCallback(
    () =>
      new Promise<PhonePosition>((resolve, reject) => {
        if (!navigator.geolocation) {
          setError("unavailable");
          reject(new Error("unavailable"));
          return;
        }
        setError(undefined);
        navigator.geolocation.getCurrentPosition(
          position =>
            resolve({
              lat: position.coords.latitude,
              lon: position.coords.longitude,
              accuracy: Math.round(position.coords.accuracy),
            }),
          failure => {
            const reason = failure.code === failure.PERMISSION_DENIED ? "denied" : failure.code === failure.TIMEOUT ? "timeout" : "unavailable";
            setError(reason);
            reject(new Error(reason));
          },
          { enableHighAccuracy: true, timeout: POSITION_TIMEOUT_MS, maximumAge: 0 },
        );
      }),
    [],
  );

  return { request, error };
}
